import { COURSES_CALENDAR_HOUR_ROW_COUNT } from "../../constants/courses-calendar.constants";
import { CourseRouteTypeEnum } from "../../enums/course-route-type.enum";
import {
  CoursesCalendarRowsFilter,
  ICoursesCalendarSlotDto,
} from "../../models/courses-calendar.models";
import {
  ALL_COURSES_CALENDAR_HOUR_INDICES,
  COURSES_CALENDAR_TIME_PARSE_RADIX,
} from "./courses-calendar.constants";

const slotHourIndex = (slot: ICoursesCalendarSlotDto): number | null => {
  const h = parseInt(
    slot.timeLabel.split(":")[0] ?? "0",
    COURSES_CALENDAR_TIME_PARSE_RADIX,
  );
  if (Number.isNaN(h) || h < 0 || h >= COURSES_CALENDAR_HOUR_ROW_COUNT) {
    return null;
  }
  return h;
};

const slotMatchesRowsFilter = ({
  slot,
  filter,
}: {
  slot: ICoursesCalendarSlotDto;
  filter: CoursesCalendarRowsFilter;
}): boolean => {
  switch (filter) {
    case "all":
    case "with_courses":
      return true;
    case "flex_only":
      return slot.courseRouteType === CourseRouteTypeEnum.Flex;
    case "shuttles_only":
      return slot.courseRouteType === CourseRouteTypeEnum.Shuttle;
    default: {
      const _exhaustive: never = filter;
      return _exhaustive;
    }
  }
};

export const filterCoursesCalendarSlotsByRowsFilter = ({
  slots,
  filter,
}: {
  slots: ICoursesCalendarSlotDto[];
  filter: CoursesCalendarRowsFilter;
}): ICoursesCalendarSlotDto[] => {
  if (filter === "all" || filter === "with_courses") {
    return slots;
  }
  return slots.filter(slot => slotMatchesRowsFilter({ slot, filter }));
};

export const getCoursesCalendarVisibleHourIndices = ({
  slots,
  filter,
}: {
  slots: ICoursesCalendarSlotDto[];
  filter: CoursesCalendarRowsFilter;
}): number[] => {
  if (filter === "all") {
    return ALL_COURSES_CALENDAR_HOUR_INDICES;
  }

  const hours = new Set<number>();
  for (const slot of slots) {
    if (!slotMatchesRowsFilter({ slot, filter })) {
      continue;
    }
    const hour = slotHourIndex(slot);
    if (hour !== null) {
      hours.add(hour);
    }
  }
  return Array.from(hours).sort((a, b) => a - b);
};
